import { render, staticRenderFns } from "./prodDisplay.vue?vue&type=template&id=d3277850&scoped=true"
import script from "./prodDisplay.vue?vue&type=script&lang=js"
export * from "./prodDisplay.vue?vue&type=script&lang=js"
import style0 from "./prodDisplay.vue?vue&type=style&index=0&id=d3277850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3277850",
  null
  
)

export default component.exports